import React, { Dispatch } from "react"
import SidePanelForm from "components/Builder/components/SidePanelForm"
import { FixedBlockType, Form } from "sharedTypes"
import RegistrationSettings from "./RegistrationSettings"
import SubmissionSettings, { FormWithSubmitButtonLabelMode } from "./SubmissionSettings"
import PlusOneSettings from "./PlusOneSettings"
import MessagingSettings from "./MessagingSettings"

type Props = {
  form: Form
  setForm: Dispatch<React.SetStateAction<Form | undefined>>
  selectedFixedBlockType: FixedBlockType
  onCancel: (form) => void
}

const FixedBlockEditorPanel = ({
  form,
  setForm,
  selectedFixedBlockType,
  onCancel,
}: Props) => {
  const saveForm = (values) => {
    setForm(values)
  }

  const initialValues = {
    profileNameRequired: true,
    profileEmailRequired: true,
    plusOneNameRequired: true,
    ...form,
    plusOneNameEnabled: form.plusOneNameEnabled ?? true,
    plusOneEmailEnabled: form.plusOneEmailEnabled ?? true,
    plusOneEmailRequired: form.plusOneEmailRequired ?? false,
    submitButtonLabel: form.submitButtonLabel ?? "",
    submitButtonLabelMode: (form as FormWithSubmitButtonLabelMode).submitButtonLabelMode
      ?? (form.submitButtonLabel ? "override" : "default"),
    submitButtonCustomLabel: (form as FormWithSubmitButtonLabelMode).submitButtonCustomLabel
      ?? form.submitButtonLabel ?? "",
  }

  return (
    <SidePanelForm
      onChange={saveForm}
      onCancel={onCancel}
      initialValues={initialValues}
    >
      {({ control, setValue }) => {
        switch (selectedFixedBlockType) {
          case FixedBlockType.Registration:
            return (
              <RegistrationSettings
                form={form}
                control={control}
                setValue={setValue}
              />
            )
          case FixedBlockType.GuestName:
            return (
              <MessagingSettings
                form={form}
                control={control}
                setValue={setValue}
              />
            )
          case FixedBlockType.Payment:
          case FixedBlockType.FormSubmission:
            return (
              <SubmissionSettings
                form={form}
                control={control}
                setValue={setValue}
              />
            )
          case FixedBlockType.PlusOnes:
            return (
              <PlusOneSettings
                control={control}
                setValue={setValue}
                form={form}
              />
            )
          default:
            return <></>
        }
      }}
    </SidePanelForm>
  )
}

export default FixedBlockEditorPanel
